import * as core from "@froppio/web-telemetry";
import { apiBaseUrl } from "../api/apiConfig";
import { ApiError } from "../api/apiTypes";
import { appVersion } from "../appVersion";
import type { TelemetryEventName, TelemetryEvents, UiActionName } from "./telemetryEvents";

export {
  getSupportId, getTelemetrySessionId, installClickTelemetry, reactRootErrorHandlers, reportError,
  setTelemetryUser, trackApiFailure,
} from "@froppio/web-telemetry";

const BUSINESS_SCOPE = /^\/b\/([^/]+)/;

/** Starts Faro when `VITE_FARO_URL` is configured. Call once, before rendering, so startup crashes are captured. */
export function initTelemetry() {
  core.initTelemetry({
    url: import.meta.env.VITE_FARO_URL,
    appName: "froppio-forms",
    version: appVersion,
    environment: import.meta.env.VITE_FARO_ENVIRONMENT?.trim() || import.meta.env.MODE,
    apiBaseUrl,
  });
}

export const trackEvent = <K extends TelemetryEventName>(name: K, attributes: TelemetryEvents[K]) =>
  core.trackEvent(name, attributes);

/** Spread onto a control so pressing it starts a Faro user action that links the work it triggers. */
export const userAction = (name: UiActionName) => core.userAction(name);

export const createTelemetryCaches = () =>
  core.createTelemetryCaches({ statusOf: error => (error instanceof ApiError ? error.Status : undefined) });

/** Business scope from the route, kept on the telemetry user as `businessId`. */
export const routeScope = (pathname: string) => ({ businessId: BUSINESS_SCOPE.exec(pathname)?.[1] });
